import type { CommunityDetail } from 'models';
import { canManageAssets } from 'permissions';
import { Card, FolderLineIcon } from 'ui';
import { AssetsHeaderButtons, AssetsTable, useAssetsFoldersParents } from 'features/assets';
import { useUser } from 'features/auth';

type P = {
  community: CommunityDetail;
};

const Assets = ({ community }: P) => {
  const { railsUserData: viewer } = useUser();
  const { addParentFolder, lastParentFolder, navigateToParentFolder, navigateToRoot, parents } =
    useAssetsFoldersParents();
  const canManage = canManageAssets({ community, viewer });

  return (
    <Card
      extra={canManage ? <AssetsHeaderButtons communityId={community.id} parentId={lastParentFolder?.id} /> : null}
      title={<Card.Title icon={<FolderLineIcon />}>Files</Card.Title>}
    >
      <AssetsTable
        canManage={canManage}
        filter={{ communityId: community.id }}
        folders={parents}
        onNavigateToParentFolder={navigateToParentFolder}
        onNavigateToRoot={navigateToRoot}
        onOpenFolder={addParentFolder}
        parentFolder={lastParentFolder}
      />
    </Card>
  );
};

export default Assets;
